import http from "@/services/http";

export async function fetch(id: string, numposts: number) {
  const { data } = await http().get(
    `${globalThis.env.API_APOLLO_MIDDLEWARE}/DiscussionThreads?topicId=${id}&numPosts=${numposts}`
  );
  return data;
}
